/**
 * App.vue で、どの外枠（レイアウト）で画面を出すかを決める（指示書 A1）。
 *
 * 以前は「認証済みかどうか」だけで外枠を切り替えていた。そのため、ログイン画面（/）で認証が成功した瞬間
 * （SIGNED_IN）に外枠が変わり、ログイン画面が破棄されて、空の新しいログイン画面が作り直されていた。
 * ログインの入口と回復画面は、認証状態にかかわらず、同じ枠（レイアウトなし）で出す。
 * それ以外のルートの表示は、従来どおり（認証済みなら AppLayout、未認証なら枠なし）。
 */

/** 認証状態で外枠を変えないルート（ログイン入口・回復画面） */
export const BARE_ROUTE_NAMES = new Set(['Login', 'ManagerLogin', 'ConnectionError'])

/**
 * @param {{ routerReady: boolean, path: string, routeName?: string|symbol|null, isAuthenticated: boolean }} p
 * @returns {'loading'|'instructor'|'signup_verify'|'bare'|'app'|'public'}
 */
export function chooseAppShell({ routerReady, path, routeName, isAuthenticated }) {
  if (!routerReady) return 'loading'
  const p = typeof path === 'string' ? path : ''
  if (p.startsWith('/instructor')) return 'instructor'
  if (p === '/signup/verify') return 'signup_verify'
  if (routeName != null && BARE_ROUTE_NAMES.has(String(routeName))) return 'bare'
  if (isAuthenticated) return 'app'
  return 'public'
}
